<template>
  <v-echarts
    :options="echartsOptions"
    autoresize
    theme="light"
    :style="`width:100%;height:650px`"
    ref="vEcharts"
  ></v-echarts>
</template>
<script>
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/toolbox'
export default {
  props: { options: { type: Object, default: () => {} } },
  computed: {
    echartsOptions() {
      let { series = [] } = this.options
      series = series.map((s) => {
        return {
          ...s,
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#5470C6',
            width: 4,
          },
          markPoint: {
            data: [
              { type: 'max', name: 'Max' },
              { type: 'min', name: 'Min' },
            ],
          },
        }
      })
      const legend = series.map((s) => s.name)

      let options = {
        xAxis: {
          type: 'category',
          data: this.options.xAxis,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} °C',
          },
        },
        series,
        animation: false,
        dataZoom: [
          {
            type: 'slider',
            show: true,
          },
        ],
        legend: {
          data: legend,
        },
        tooltip: {
          trigger: 'axis',
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true },
          },
        },
      }
      return options
    },
  },
  methods: {
    getImagesBase64() {
      const { chart } = this.$refs.vEcharts
      return chart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff',
        excludeComponents: ['toolbox', 'dataZoom'],
      })
    },
  },
}
</script>
